import { Reveal } from "@/components/Reveal";

const values = [
    {
        numeral: "I",
        name: "Vision",
        body: "Crafting cinematic foresight and uncompromising creative direction for elite brands.",
        testid: "value-card-vision",
    },
    {
        numeral: "II",
        name: "Verity",
        body: "Executing every frame with absolute truth, authenticity, and flawless precision.",
        testid: "value-card-verity",
    },
    {
        numeral: "III",
        name: "Vault",
        body: "Protecting client assets with ironclad structure, security, and structured delivery.",
        testid: "value-card-vault",
    },
];

const Values = () => (
    <section
        id="standard"
        data-testid="the-vellor-standard-section"
        className="relative overflow-hidden px-6 py-32 sm:py-40 lg:px-16 lg:py-48"
    >
        <div className="royal-flare absolute inset-x-0 top-0 h-[50vh] opacity-70" />

        <div className="relative mx-auto max-w-6xl">
            <Reveal className="text-center">
                <p className="mb-8 font-display text-[10px] uppercase tracking-[0.5em] text-[#270057]">
                    Core Values
                </p>
                <h2
                    data-testid="the-vellor-standard-title"
                    className="font-serif text-4xl font-normal tracking-[-0.01em] text-[#270057] sm:text-5xl lg:text-6xl"
                >
                    The Vellor Standard
                </h2>
                <div className="royal-rule mx-auto mt-12 w-32" />
            </Reveal>

            <div className="mt-24 grid grid-cols-1 gap-14 md:grid-cols-3 lg:mt-32 lg:gap-16">
                {values.map((v, i) => (
                    <Reveal key={v.numeral} delay={i * 0.15}>
                        <div
                            data-testid={v.testid}
                            className="group border-t border-[#270057]/20 pt-10 text-center transition-colors duration-700 hover:border-[#270057]/60"
                        >
                            <span className="font-serif text-2xl italic text-[#270057] transition-colors duration-700 group-hover:text-[#270057]">
                                {v.numeral}.
                            </span>
                            <h3 className="mt-6 font-serif text-3xl font-medium text-[#270057]">
                                {v.name}
                            </h3>
                            <p className="mx-auto mt-5 max-w-xs text-base font-normal leading-relaxed text-[#270057]">
                                {v.body}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Values;
